<template>
  <div class="content-div">
    <div class="form-box">
      <el-form :rules="rules" ref="ruleForm" :model="drawerForm" label-width="90px">
        <div class="top-title">基础信息</div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="账号 : " prop="account">
              <el-input v-model="drawerForm.account" placeholder="请输入" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码 : " prop="password">
              <el-input v-model="drawerForm.password" placeholder="请输入" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="确认密码 : " prop="againPassword">
              <el-input v-model="drawerForm.againPassword" placeholder="请输入" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="top-title">详细信息</div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名 : " prop="username">
              <el-input v-model="drawerForm.username" placeholder="请输入" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号码 : " prop="phone">
              <el-input v-model="drawerForm.phone" placeholder="请输入" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="top-title">职责信息</div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="所属角色 : " prop="roleId">
              <el-select v-model="drawerForm.roleId" size="mini" placeholder="请选择">
                <el-option
                    v-for="item in AreaData"
                    :key="item.id"
                    :label="item.roleName"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属企业 : " prop="parentCodes">
              <el-cascader
                  :show-all-levels="false"
                  :props="defaultProps"
                  size="mini"
                  v-model="drawerForm.parentCodes"
                  :options="cascaderOptions"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="bottom-btn">
      <el-button :loading="submitType" @click="submitData(1)" type="primary" size="mini">确定</el-button>
      <el-button @click="submitData(2)" size="mini">取消</el-button>
    </div>
  </div>
</template>

<script>
import {getUserRoleList, addUser, updateUser} from "../../../common/accountApi";
import {getAreaTree} from "../../../common/enterpriseApi";

export default {
  name: "accountDialog",
  props: {
    drawerForm: {
      type: Object,
    },
    dialogType: {
      type: Number
    }
  },
  data() {
    var validatePass2 = (rule, value, callback) => {
      console.log(value)
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.drawerForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      rules: {
        account: [
          {required: true, message: '请输入账号', trigger: 'blur'},
          {max: 20, message: '最多可输入20个字符', trigger: 'blur'}
        ],
        phone: [
          {required: false, message: '请输入手机号', trigger: 'blur'},
          {
            pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: '请输入正确手机号'
          },
        ],
        username: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
          {max: 20, message: '最多可输入20个字符', trigger: 'blur'}
        ],
        roleId: [
          {required: true, message: '请选择所属角色', trigger: 'change'}
        ],
        parentCodes: [
          {required: true, message: '请选择所属企业', trigger: 'change'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {
            pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{6,18}$/,
            message: '密码至少包括大/小写字母、标点符号中的至少两种'
          }
        ],
        againPassword: [
          {required: true, validator: validatePass2, trigger: 'blur'}
        ]
      },
      AreaData: [],
      submitType: false,
      cascaderOptions: [],
      defaultProps: {
        children: 'menuChildren',
        value: 'orgCode',
        label: 'orgName',
        checkStrictly: true
      }
    }
  },
  mounted() {
    this.getUserRoleList()
    this.getAreaTree()
  },
  methods: {
    // 数据提交
    async submitData(type) {
      /*
        * dialogType
        * 1   新增
        * 2   修改
        * */
      this.submitType = true
      if (this.drawerForm.parentCodes && this.drawerForm.parentCodes.length) {
        this.$set(this.drawerForm, 'orgCode', this.drawerForm.parentCodes[this.drawerForm.parentCodes.length - 1])
      }
      if (type === 1) {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            if (this.dialogType === 1) {
              try {
                const res = await addUser(this.drawerForm)
                if (res.code === 200) {
                  this.$notify.success({
                    title: '成功提示',
                    message: '账号新增成功'
                  })
                  this.submitType = false
                  this.$emit('drawerClose')
                } else {
                  this.$notify.error({
                    title: '错误提示',
                    message: res.msg
                  })
                  this.submitType = false
                }
              } catch (e) {
                this.submitType = false
                console.log(e)
              }
            } else {
              try {
                const res = await updateUser(this.drawerForm)
                if (res.code === 200) {
                  this.$notify.success({
                    title: '成功提示',
                    message: '账号修改成功'
                  })
                  this.submitType = false
                  this.$emit('drawerClose')
                } else {
                  this.$notify.error({
                    title: '错误提示',
                    message: res.msg
                  })
                  this.submitType = false
                }
              } catch (e) {
                this.submitType = false
                console.log(e)
              }
            }
          } else {
            this.submitType = false
            console.log('error submit!!');
            return false;
          }
        });
      } else {
        this.$emit('drawerClose')
      }
    },
    // 获取角色列表
    async getUserRoleList() {
      try {
        const res = await getUserRoleList({pageNo: 1, pageSize: 0})
        if (res.code === 200) {
          this.AreaData = res.data
        } else {
          this.$notify.error({
            title: '错误提示',
            message: res.msg
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 获取企业列表
    async getAreaTree() {
      try {
        const res = await getAreaTree()
        if (res.code === 200) {
          this.cascaderOptions = res.data
        } else {
          this.$notify.error({
            title: '错误提示',
            message: res.msg
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
  }
}
</script>

<style scoped>
.content-div /deep/ .el-form-item__error {
  padding-top: 0 !important;
}

.content-div {
  width: 100%;
  height: calc(100% - 40px);
}

.top-title {
  text-align: left;
  margin-bottom: 20px;
  margin-top: 20px;
  font-size: 18px;
  font-weight: 700;
}

.bottom-btn {
  position: absolute;
  bottom: 20px;
  right: 20px;
}

.form-box {
  box-sizing: border-box;
  padding: 0 60px 0 20px;
}

.form-box /deep/ .el-form-item {
  margin-bottom: 10px !important;
}
</style>
